import { render, staticRenderFns } from "./WizardErrors.vue?vue&type=template&id=b116b20c"
import script from "./WizardErrors.vue?vue&type=script&lang=js"
export * from "./WizardErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports